import { CREATE, READ } from '../constants/actionTypes'
import * as api from '../api'

export const getProducts = () => async (dispatch) => {
    try {
        const {data} = await api.getProducts()
        dispatch({type: READ, payload: data})
    } catch (error) {
        console.log(error);
    }
}

export const searchProducts = (searchQuery) => async (dispatch) => {
    try {
        const {data: {data} } = await api.searchProducts(searchQuery)
        dispatch({ type: READ, payload: data });
    } catch (error) {
        console.log(error);
    }
};

export const createProduct = (product) => async (dispatch) => {
   try {
        const {data} = await api.createProduct(product)
        dispatch({type: CREATE, payload: data})
   } catch (error) {
       console.log(error);
   }
}